import { withStyles } from '@material-ui/core';
import BreakableText from './BreakableText';
const styles = (theme) => ({
  label: { color: theme.printTableLabel, fontSize: theme.textFontSize, fontWeight: 700 }
});
const RenderLabel = ({ label, classes }) => {
  return <BreakableText className={classes.label} text={label} />;
};

export default withStyles(styles)(RenderLabel);
